export const fmtRp = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return "Rp " + Math.round(n).toLocaleString("id-ID");
};

export const fmtNum = (n, digits = 1) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return n.toLocaleString("id-ID", { minimumFractionDigits: 0, maximumFractionDigits: digits });
};

export const fmtKwh = (n) => `${fmtNum(n, 2)} kWh`;
export const fmtKw = (n) => `${fmtNum(n, 1)} kW`;
export const fmtKwp = (n) => `${fmtNum(n, 2)} kWp`;
